import Swup from "swup";
import SwupScrollPlugin from "@swup/scroll-plugin"; // for scrolling to anchor links
import SwupPreloadPlugin from "@swup/preload-plugin"; // for preloading (some) content
import SwupProgressPlugin from "@swup/progress-plugin"; // displays page loading progress bar
import SwupGtmPlugin from "@swup/gtm-plugin"; // for Google Tag Manager
import SwupScriptsPlugin from "@swup/scripts-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import {initDefaultSwiper, initCreativeSwiper } from "./js/swiper";
import initTabs from "./js/tabs";
import initSlidingPushmenu from "./js/pushMenu";
import preLoader from "./js/preLoader";
import initAnimations from "./js/animation";
import initDropdown from "./js/dropdown";
import initModals from "./js/modals";
import initDrawers from "./js/drawers";
import initCategoryFilter from "./js/categoryFilter";
import initCubeForm from "./js/cubeform";
import initAccordion from "./js/accordion";
import initUploads from "./js/uploads";
import initOrderTabs from "./js/OrderTabs";

let SWUP_ENABLED = false; // page transitions

// invoke all javascript

function initOnce() {
	// pushmenu and dropdowns are not swupped: init these functions only once!
	initSlidingPushmenu();
	initDropdown();
}

function init() {
	// functions that need
	initAnimations();
	preLoader();
	initDefaultSwiper();
	initCreativeSwiper();
	initTabs();
	initModals();
	initDrawers();
	initCategoryFilter();
	initCubeForm();
	initAccordion();
	initUploads();
	initOrderTabs();

}

initOnce();
init();

function reinit() {
	// for swup page transitions
	// resets for scrolltrigger to work correctly with Swup
	window.scrollTo(0, 0);

	for (const trigger of ScrollTrigger.getAll()) {
		trigger.kill(true);
	}

	// hide all dropdowns after swup
	let allSubmenus = document.querySelectorAll(".sub-menu");
	[].forEach.call(allSubmenus, (submenu) => {
		submenu.classList.remove("sub-menu--active");
	});

	// init functions
	init();
}

// const options = {};

// SWUP adds page transitions
// it replaces the page main content including the footer (see header.php and footer.php)
// use data-no-swup on a link to disable swup on that page (e.g. when the page contains scripts that are reloaded incorrectly by swup)
// OR use a linkSelector to specify with pages with swup transitions

// the swup animation is defined in base/swup.scss

if (SWUP_ENABLED) {
	const swup = new Swup({
		plugins: [
			new SwupScrollPlugin(),
			new SwupPreloadPlugin(),
			new SwupProgressPlugin(),
			new SwupGtmPlugin(),
			new SwupBodyClassPlugin(),
			new SwupScriptsPlugin({
				optin: true,
			}),
		],
	});

	swup.on("contentReplaced", reinit); // this event runs for every page view after initial load
}

console.log(
	'%c Created by Commandos',
	'display: inline-block;text-transform:uppercase;background:black;font-weight: bold;color: white; padding:10px 20px;margin: 16px 0',
	'https://commandos.nl/'
);

var showSummary = document.querySelector(".show__summary");
var summary = document.querySelector(".summary");
if(showSummary != null) {
	showSummary.onclick = function () {
		showSummary.classList.toggle("active");
		summary.classList.toggle("active");
	};
}
